import { GalleryImage } from 'react-gesture-gallery';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface ContainerProps {
  height?: number;
}

interface StepperProps {
  size?: number;
}

export const PictureContainer = styled.div.attrs<any, ContainerProps>((): any => {})`
  position: relative;
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : '128px')};
`;

export const Image = styled(GalleryImage)`
  & > img {
    max-height: none !important;
    width: 100%;
  }
`;

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  bottom: -15px;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Stepper = styled.span.attrs<any, StepperProps>((): any => {})`
  margin: 9px 0;
  width: ${({ size }) => (size ? `${size}px` : '8px')};
  height: ${({ size }) => (size ? `${size}px` : '8px')};
  border-radius: 8px;
  background-color: ${ColorPalette.HEX.White};

  &:not(:last-child) {
    margin-right: 9px;
  }
`;
